$(document).ready(function () {
    const carousels = [
        { selector: '.three-images-container', defaultSlides: 3 },
        { selector: '.two-images-container', defaultSlides: 2 },
        { selector: '.one-images-container', defaultSlides: 1 }
    ];
    carousels.forEach(carousel => {
        const $carousel = $(carousel.selector);
        if ($carousel.length) {
            initializeCarousel($carousel, carousel.defaultSlides);
        }
    });

    function initializeCarousel($carousel, defaultSlides) {
        const $wrapper = $carousel.closest('div[class$="-wrapper"]');
        const $dotsContainer = $wrapper.find('.slider-dots-container');
        const $leftArrow = $wrapper.find('.left-arrow');
        const $rightArrow = $wrapper.find('.right-arrow');
        $carousel.slick({
            slidesToShow: getItemsToShow(defaultSlides),
            slidesToScroll: 1,
            infinite: false,
            arrows: false,
            dots: false,
            swipe: true,
            touchMove: true,
            centerMode: false,
            adaptiveHeight: true,
            responsive: getResponsiveSettings(defaultSlides)
        });
        

        function getResponsiveSettings(defaultSlides) {
            if (defaultSlides === 3) {
                return [
                    { breakpoint: 1117, settings: { slidesToShow: 2, slidesToScroll: 1 } },
                    { breakpoint: 768, settings: { slidesToShow: 2, slidesToScroll: 1 } },
                    { breakpoint: 576, settings: { slidesToShow: 1, slidesToScroll: 1 } }
                ];
            } else {
                return [
                    { breakpoint: 1117, settings: { slidesToShow: 1, slidesToScroll: 1 } },
                    { breakpoint: 768, settings: { slidesToShow: 1, slidesToScroll: 1 } },
                    { breakpoint: 576, settings: { slidesToShow: 1, slidesToScroll: 1 } }
                ];
            }
        }
        setTimeout(() => $carousel.slick('setPosition'), 100);
        updateDots($carousel, $dotsContainer, 0);
        bindArrowEvents($carousel, $leftArrow, $rightArrow);
        bindDotEvents($carousel, $dotsContainer);
        bindAfterChange($carousel, $dotsContainer, $leftArrow, $rightArrow);

        $carousel.slick('slickGoTo', 0, true);
    }

    function updateDots($carousel, $dotsContainer, currentSlide) {
        const slick = $carousel.slick("getSlick");
        const totalItems = slick.slideCount;
        const itemsToShow = slick.options.slidesToShow;
        $dotsContainer.empty();
        for (let i = 0; i < totalItems; i++) {
            const isActive = (i >= currentSlide && i < currentSlide + itemsToShow) ? 'active' : '';
            $dotsContainer.append(`<span class="dot ${isActive}" data-index="${i}"></span>`);
        }
        bindDotEvents($carousel, $dotsContainer);
    }

    function bindDotEvents($carousel, $dotsContainer) {
        $dotsContainer.off('click', '.dot').on('click', '.dot', function () {
            const targetIndex = parseInt($(this).attr('data-index'));
            $carousel.slick('slickGoTo', targetIndex);
        });
    }
    let activeCarousel = null;
    function bindArrowEvents($carousel, $leftArrow, $rightArrow) {
        $leftArrow.off('click').on('click', function () {
            activeCarousel = $carousel;
            $carousel.slick('slickPrev');
        });
        $rightArrow.off('click').on('click', function () {
            activeCarousel = $carousel;
            $carousel.slick('slickNext');
        });
    }
    function bindAfterChange($carousel, $dotsContainer, $leftArrow, $rightArrow) {
        $carousel.off('afterChange').on('afterChange', function (event, slick, currentSlide) {
            updateDots($carousel, $dotsContainer, currentSlide);

            const maxIndex = slick.slideCount - slick.options.slidesToShow;
            const width = $(window).width();
            let activeColor = '#8E9093';
            let inactiveColor = '#E6E7E8';

            if (width <= 768) {
                activeColor = '#939598';
                inactiveColor = '#E6E7E8';
            }
            $leftArrow.css('pointer-events', currentSlide <= 0 ? 'none' : 'auto');
            $leftArrow.find('path').attr('fill', currentSlide <= 0 ? inactiveColor : activeColor);
            $rightArrow.css('pointer-events', currentSlide >= maxIndex ? 'none' : 'auto');
            $rightArrow.find('path').attr('fill', currentSlide >= maxIndex ? inactiveColor : activeColor);
        });
    }

    $(window).on('resize', function () {
        carousels.forEach(carousel => {
            const $carousel = $(carousel.selector);
            if ($carousel.length) {
                const $wrapper = $carousel.closest('div[class$="-wrapper"]');
                const $dotsContainer = $wrapper.find('.slider-dots-container');
                const itemsToShow = getItemsToShow(carousel.defaultSlides);
                $carousel.slick('slickSetOption', 'slidesToShow', itemsToShow, true);
                $carousel.slick('slickSetOption', 'slidesToScroll', 1, true);
                updateDots($carousel, $dotsContainer, 0);
                $carousel.slick('slickGoTo', 0, true);
            }
        });
    });

    function getItemsToShow(defaultSlides) {
        const width = $(window).width();

        if (width <= 576) {
            return 1;
        } else if (width <= 768) {
            return 1;
        } else if (width <= 1117) {
            return defaultSlides === 3 ? 2 : 1;
        } else {
            return defaultSlides;
        }
    }

    const overlay = $('#image-overlay');
    const overlayImg = $('#overlay-img');
    const closeBtn = $('.close-icon');
    const prevBtn = $('.left-arrow-nav');
    const nextBtn = $('.right-arrow-nav');
    let currentIndex = 0;
    let images = [];

    $('.three-images-container img, .two-images-container img, .one-images-container img').on('click', function () {
        const $clickedCarousel = $(this).closest('.three-images-container, .two-images-container, .one-images-container');
        activeCarousel = $clickedCarousel;
        images = $clickedCarousel.find('img').map(function () {
            return $(this).attr('src');
        }).get();
        currentIndex = images.indexOf($(this).attr('src'));
        showOverlayImage();
        overlay.removeClass('hidden');
        closeBtn.focus();
    });

    function showOverlayImage() {
        overlayImg.attr('src', images[currentIndex]);
    }

    prevBtn.on('click', function (e) {
        e.stopPropagation();
        currentIndex = (currentIndex - 1 + images.length) % images.length;
        showOverlayImage();
    });

    nextBtn.on('click', function (e) {
        e.stopPropagation();
        currentIndex = (currentIndex + 1) % images.length;
        showOverlayImage();
    });

    closeBtn.on('click', function () {
        overlay.addClass('hidden');
        images = [];
    });

    $(document).on('keyup', function (e) {
        if (!overlay.hasClass('hidden') && e.key === 'Escape') {
            overlay.addClass('hidden');
            images = [];
        }
    });

    $(document).on('keydown', function (e) {
        if (!overlay.hasClass('hidden')) {
            switch (e.key) {
                case 'ArrowLeft':
                    e.stopPropagation();
                    currentIndex = (currentIndex - 1 + images.length) % images.length;
                    showOverlayImage();
                    break;
                case 'ArrowRight':
                    e.stopPropagation();
                    currentIndex = (currentIndex + 1) % images.length;
                    showOverlayImage();
                    break;
                case 'Escape':
                    overlay.addClass('hidden');
                    images = [];
                    break;
            }
        }
        else {
            if (activeCarousel) {
                if (e.key === 'ArrowLeft') {
                    activeCarousel.slick('slickPrev');
                } else if (e.key === 'ArrowRight') {
                    activeCarousel.slick('slickNext');
                }
            }
        }
    });
});